import React from 'react';
export function Science() {
  return <section className="bg-mist py-[58px] md:py-[76px]" data-id="element-95">
      <div className="max-w-page mx-auto px-6" data-id="element-96">
        <div className="max-w-measure mx-auto" data-id="element-97">
          <h2 className="font-display font-medium text-[clamp(1.7rem,3vw,2.25rem)] leading-[1.14] m-0 mb-6 tracking-[-0.01em]" data-id="element-98">
            About the science{' '}
            <em className="italic text-teal" data-id="element-99">(the honest version)</em>
          </h2>
          <p className="text-ink text-[1.05rem] m-0 mb-[1.1em] leading-[1.7]" data-id="element-100">
            A longer exhale is associated with the body's calming,
            parasympathetic response, and a well-known Stanford study found that
            a short daily breathing practice did at least as well as meditation
            for people's mood. Both are reasons we think the slow exhale is
            worth building around.
          </p>
          <p className="text-ink-60 text-[1.05rem] m-0 leading-[1.7]" data-id="element-101">
            Worth knowing, straight from us: that study tested a guided
            breathing protocol, not our pendant, and a more recent trial found
            more muted effects. Nobody has studied Chime itself. We think the
            long exhale is real and useful — and we'd rather you hear the limits
            from us than from a comment section. Chime is a tool that supports a
            calmer moment; it is not a medical device.
          </p>
        </div>
      </div>
    </section>;
}